import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "receiving-search" }
const _hoisted_2 = {
  key: 0,
  class: "receiving-search__list"
}
const _hoisted_3 = ["onClick"]

import { onMounted, ref, watch } from 'vue'
import { iClient } from '@/types/responses'
import useDataRequest from '@/composables/useDataRequest'
import { getClientById, suggestClient } from '@/api/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientAutocomplete',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const items = ref<iClient[]>([])

const searchQuery = ref<string>()
const currentId = ref<number|undefined>()
const request = useDataRequest()

const handleQuery = (term: string) => {
  if (term) {
    searchQuery.value = term
    request.tryRequest(async () => {
      const response = await suggestClient(term)
      items.value = response.data
    })
  }
}

const handleSelect = (client: iClient) => {
  currentId.value = client.id
  searchQuery.value = client.name
  items.value = []
  emit('update:modelValue', client.id)
}

const loadCurrentClientName = () => {
  request.tryRequest(async () => {
    if (props.modelValue && props.modelValue !== currentId.value) {
      const response = await getClientById(props.modelValue)
      searchQuery.value = response.data.name
    }
  })
}

const handleClear = () => {
  searchQuery.value = ''
  currentId.value = undefined
  emit('update:modelValue', null)
}

onMounted(loadCurrentClientName)

watch(() => props.modelValue, loadCurrentClientName)


return (_ctx: any,_cache: any) => {
  const _component_custom_input = _resolveComponent("custom-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_custom_input, {
      label: "Заказчик",
      class: "receiving-search__input",
      "model-value": searchQuery.value,
      focus: !props.modelValue,
      clearable: "",
      "onUpdate:modelValue": handleQuery,
      onClear: handleClear
    }, null, 8, ["model-value", "focus"]),
    (items.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id,
              class: "receiving-search__item",
              onClick: ($event: any) => (handleSelect(item))
            }, _toDisplayString(item.name), 9, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})